import { Link } from "react-router-dom";
import { Clock, Heart, PlayCircle } from "lucide-react";
import { useMember, label } from "./MemberContext";
import { DIFF_LABEL, LockBadge, TierBadge } from "./ui";
import { exerciseTags } from "./ExerciseExtras";

export function ExerciseCard({ ex, onFav }) {
  const { meta } = useMember();
  return (
    <div className="group relative bg-[#121212] border border-white/10 hover:border-[#c1ff72]/60 transition-[border-color,transform] duration-200 hover:-translate-y-1" data-testid={`exercise-card-${ex.slug}`}>
      <Link to={`/training/uebung/${ex.slug}`} className="block" data-testid={`exercise-link-${ex.slug}`}>
        <div className="relative aspect-[16/10] overflow-hidden bg-[#1A1A1A]">
          {ex.image_url && <img src={ex.image_url} alt="" loading="lazy" className={`w-full h-full object-cover transition-transform duration-500 group-hover:scale-105 ${ex.locked && ex.lock_reason !== "login" ? "opacity-40" : "opacity-80"}`} />}
          <div className="absolute inset-0 bg-gradient-to-t from-[#121212] via-transparent to-transparent" />
          <div className="absolute top-3 left-3 flex gap-1.5"><TierBadge tier={ex.access} />{ex.locked && ex.lock_reason !== "login" && <LockBadge />}</div>
          {ex.has_video && <PlayCircle className="absolute bottom-3 right-3 w-6 h-6 text-[#c1ff72]" />}
        </div>
        <div className="p-5">
          <p className="text-[10px] uppercase tracking-[0.2em] text-[#c1ff72] mb-2">{label(meta, "categories", ex.categories[0])}</p>
          <p className="font-['Bebas_Neue'] text-2xl leading-none text-white">{ex.title}</p>
          <div className="flex items-center gap-4 mt-3 text-xs text-[#71717A]">
            <span className="flex items-center gap-1"><Clock className="w-3.5 h-3.5" />{ex.duration_min} Min</span>
            <span>{DIFF_LABEL[ex.difficulty]}</span>
            {ex.has_video && ex.video_duration && <span className="flex items-center gap-1 text-[#c1ff72]"><PlayCircle className="w-3.5 h-3.5" />{Math.round(ex.video_duration)} s Video</span>}
          </div>
          <p className="text-[11px] text-[#A1A1AA] mt-2 line-clamp-1" data-testid={`exercise-card-tags-${ex.slug}`}>{exerciseTags(ex).join(" · ")}</p>
        </div>
      </Link>
      {onFav && (
        <button onClick={() => onFav(ex)} aria-label="Favorit" data-testid={`fav-toggle-${ex.slug}`}
          className="absolute top-3 right-3 w-9 h-9 flex items-center justify-center bg-black/60 backdrop-blur border border-white/10 active:scale-90 transition-transform">
          <Heart className={`w-4 h-4 ${ex.favorite ? "fill-[#c1ff72] text-[#c1ff72]" : "text-white"}`} />
        </button>
      )}
    </div>
  );
}

export const ExerciseGrid = ({ items, onFav, testId }) => (
  <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4" data-testid={testId}>
    {items.map((ex, i) => <div key={ex.exercise_id} className="animate-in fade-in slide-in-from-bottom-2 duration-500 fill-mode-both" style={{ animationDelay: `${Math.min(i, 12) * 40}ms` }}><ExerciseCard ex={ex} onFav={onFav} /></div>)}
  </div>
);
